import { useLocale } from "Infrastructure/Hooks/useLocale";
import { Box, Typography } from "@mui/material";

type NumberCellProps = {
  value: number;
};

export const NumberCell = ({ value }: NumberCellProps) => {
  const locale = useLocale();
  const formattedValue = value.toLocaleString(locale);
  return (
    <Box textAlign="right">
      <Typography variant="body2">{formattedValue}</Typography>
    </Box>
  );
};
